import {XauditModel} from '../xaudit.model';
import {CaseProcedureConfigurationModel} from '../caseProcedures/case-procedure-configuration.model';
import {DataPatientCaseModel} from './data-patient-case.model';
import {PatientCaseWorkItemFormDataModel} from '../forms/data/patient-case-work-item-form-data.model';
import {DataPatientCaseWorkItemToothModel} from '../teeth/data-patient-case-work-item-tooth.model';
import {ToothConfigurationModel} from '../teeth/tooth-configuration.model';
import { DoctorByTDOCIDModel } from 'src/app/modules/ar/models/doctor-by-tdocid.model';

// TODO: Only seems to be used by accounts receivable
export class DataPatientCaseWorkItemModel extends XauditModel{
  CaseWorkItemId: string;
  PatientCaseId: string;
  LOCID: number;
  PatientCasePhaseID: string;
  ToothID: string;
  CaseProcedureId: string;
  Description: string;
  enumCaseWorkItemStatusID: string;
  StatusOn: Date;
  StatusBy: string;
  WorkItemOrder: number;
  Status: string;

  ProviderDoctorContactID: string;
  ProviderDoctorID: string;
  WorkItemEventID: string;
  EventDateStart: Date;
  ProcedureCode: string;
  Selected: boolean;

  dataPatientCaseItemForms: PatientCaseWorkItemFormDataModel[];
  dataPatientCaseWorkItemForms: PatientCaseWorkItemFormDataModel[];
  dataPatientCaseItemTeeth: DataPatientCaseWorkItemToothModel[];
  dataPatientCaseWorkItemTeeth: DataPatientCaseWorkItemToothModel[];
  dataPatientCase: DataPatientCaseModel;
  cfgCaseProcedure: CaseProcedureConfigurationModel;
  cfgTooth: ToothConfigurationModel;

  //view fields
  ProviderDoctor: DoctorByTDOCIDModel;
}
